import type { UseDealSourceFetch } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import type { OptionsList, OptionsMap } from '@openx/types/options';
import { produceSortedOptionsKeys } from '@openx/utils/lib/sortedOptions';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';

export const useDealSourceFetch: UseDealSourceFetch = () => {
  const { data } = useOptionsByPathQuery({
    variables: {
      path: 'deal.deal_source',
    },
  });

  const dealSource = useMemo<OptionsMap>(
    () =>
      data?.optionsByPath.reduce((acc, option) => {
        if (option) acc[option.id] = { id: option.id, name: option.name };

        return acc;
      }, {}) || {},
    [data?.optionsByPath]
  );

  const dealSourceOptions = useMemo(() => produceSortedOptionsKeys(dealSource), [dealSource]);
  const dealSourceOptionsList = useMemo(
    () => data?.optionsByPath.map(option => ({ id: option?.id, name: option?.name })) ?? [],
    [data]
  ) as OptionsList;

  return {
    dealSource,
    dealSourceOptions,
    dealSourceOptionsList,
  };
};
